// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contextual-panel .panel-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Context Sections */
.context-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: rgba(40, 40, 40, 0.6);
  border-radius: 6px;
  border-left: 3px solid #0066cc;
  transition: all 0.2s ease;
}

.context-section:hover {
  background: rgba(50, 50, 50, 0.7);
  border-left-color: #0088ff;
}

.section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888888;
}

.section-value {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  word-break: break-word;
}

/* Special Styling for Specific Fields */
.patient-id {
  font-family: 'Courier New', monospace;
  color: #4ecdc4;
  font-weight: 600;
}

.modality-badge {
  display: inline-block;
  padding: 4px 10px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Extensible Section */
.context-section.extensible {
  border-left-color: #ffa500;
}

.extensible-placeholder {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.placeholder-text {
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #888888;
  line-height: 1.6;
}

.icon-placeholder {
  margin-right: 6px;
  font-size: 14px;
}

/* Session Info */
.context-section.session-info {
  border-left-color: #00a855;
  background: rgba(0, 168, 85, 0.1);
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  animation: pulse 2s ease-in-out infinite;
}

.status-dot.active {
  background: #00a855;
  box-shadow: 0 0 8px rgba(0, 168, 85, 0.6);
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

/* Loading State */
.contextual-panel .panel-content.loading {
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Error State */
.contextual-panel .panel-content.error {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6b6b;
}

/* Empty State */
.contextual-panel .panel-content.empty {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888888;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/ContextualDataPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".contextual-panel .panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Context Sections */\n.context-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  background: rgba(40, 40, 40, 0.6);\n  border-radius: 6px;\n  border-left: 3px solid #0066cc;\n  transition: all 0.2s ease;\n}\n\n.context-section:hover {\n  background: rgba(50, 50, 50, 0.7);\n  border-left-color: #0088ff;\n}\n\n.section-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888888;\n}\n\n.section-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  word-break: break-word;\n}\n\n/* Special Styling for Specific Fields */\n.patient-id {\n  font-family: 'Courier New', monospace;\n  color: #4ecdc4;\n  font-weight: 600;\n}\n\n.modality-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: #ffffff;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Extensible Section */\n.context-section.extensible {\n  border-left-color: #ffa500;\n}\n\n.extensible-placeholder {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.placeholder-text {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  color: #888888;\n  line-height: 1.6;\n}\n\n.icon-placeholder {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n/* Session Info */\n.context-section.session-info {\n  border-left-color: #00a855;\n  background: rgba(0, 168, 85, 0.1);\n}\n\n.status-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.status-dot.active {\n  background: #00a855;\n  box-shadow: 0 0 8px rgba(0, 168, 85, 0.6);\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* Loading State */\n.contextual-panel .panel-content.loading {\n  min-height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Error State */\n.contextual-panel .panel-content.error {\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ff6b6b;\n}\n\n/* Empty State */\n.contextual-panel .panel-content.empty {\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #888888;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
